<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Chairman's Message</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a routerLink="javascript(0);">Chairman's Message</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="chairman-msg ptb--100 ">
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-9">
        <blockquote class="blockquote-div">
          <p>Education is not the learning of facts, but the training of the mind to think
          </p>
          <h6>- Albert Einstein</h6>
        </blockquote>
        <p>This is verbatim applicable to the school of thought which RGI is all about. My Father Lt. Shri Gyanchandji
          H. Raisoni was a visionary and an inspiration. He aspired for a group of institutions impeccable, excellent
          and powerful in the context of the Indian society. It is his dream which has been accomplished in the form of
          The Raisoni Group of Institutions.</p>
        <p>Over the last few decades, the development of technology and innovation has aided us in refraining from the
          barriers. It has instilled life to creativity. Presently, the world economy is experiencing an unprecedented
          change. Our belief lies in our young students. We believe that the awareness imparted to them will continue to
          grow and sprawl. In order to pave their way, we have a team of highly qualified Educators, Lecturers and
          Professors. We have the best of infrastructure and a dedicated placement cell. We have established a benchmark
          for ourselves. Undoubtedly, we are the most preferred institute for students in Central India. We are proud to
          have developed diverse, creative and team-oriented professionals in the past and will continue to pursue the
          same in future. The vision of RGI is to provide affordable, relevant, industry-oriented and world-class
          professional education to all. RGI wishes you to grow and continue on your successful endeavors. I am
          optimistic that RGI will sustain to be the blistering flame of knowledge and opportunities with the assiduous
          team we have.</p>
        <blockquote class="blockquote-div mt-3">
          <p>Think Education Think Raisoni
          </p>
        </blockquote>
      </div>
      <div class="col-12 col-lg-3">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/faculty/chairman.webp" alt="Shri. Sunil Raisoni | GHRCACS, PUNE" class="img-fluid w-100">
        <div class="box">
          <h4>Shri. Sunil Raisoni</h4>
          <p>Chairman</p>
        </div>
      </div>
    </div>
  </div>
</section>
